import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Create axios instance with default headers
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('sessionToken');
      window.location.href = '/signin';
    }
    return Promise.reject(error);
  }
);

// Get all conversations for the business
export const getConversations = async () => {
  try {
    const response = await apiClient.get('/api/messages/conversations');
    return response.data;
  } catch (error) {
    console.error('Error fetching conversations:', error);
    throw error;
  }
};

// Get messages for a specific conversation
export const getMessagesByConversation = async (conversationId, page = 1, limit = 50) => {
  try {
    const response = await apiClient.get(`/api/messages/conversation/${conversationId}`, {
      params: { page, limit }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching messages:', error);
    throw error;
  }
};

// Get all messages for the business
export const getMessages = async () => {
  try {
    const response = await apiClient.get('/api/messages');
    return response.data;
  } catch (error) {
    console.error('Error fetching messages:', error);
    throw error;
  }
};

export const createMessage = async (payload) => {
  const response = await apiClient.post('/api/messages', payload);
  return response.data;
};

export const getHumanAgentEnabled = async () => {
  const response = await apiClient.get('/api/business/human-agent');
  return response.data;
};

export const updateHumanAgentEnabled = async (human_agent_enabled) => {
  const response = await apiClient.put('/api/business/human-agent', { human_agent_enabled });
  return response.data;
};

export const updateBusiness = async (businessId, payload) => {
  const response = await apiClient.put(`/api/business/${businessId}`, payload);
  return response.data;
};

export const getChatSessions = async () => {
  const response = await apiClient.get('/api/chat-sessions');
  return response.data;
};

export const ensureChatSession = async (conversation_id) => {
  const response = await apiClient.post('/api/chat-sessions/ensure', { conversation_id });
  return response.data;
};

export const closeChatSession = async (sessionId) => {
  const response = await apiClient.post(`/api/chat-sessions/${sessionId}/close`);
  return response.data;
};

export const getAgentStatus = async () => {
  const response = await apiClient.get('/api/agent/status');
  return response.data;
};

export const updateAgentStatus = async (status) => {
  const response = await apiClient.post('/api/agent/status', { status });
  return response.data;
};

export const joinChatSession = async (sessionId) => {
  const response = await apiClient.post(`/api/chat-sessions/${sessionId}/join`);
  return response.data;
};

export const presencePing = async () => {
  const response = await apiClient.post('/api/presence/ping');
  return response.data;
};

